import { useAuth, useOrganization } from '@clerk/clerk-react';
import { enrolledAutoSyncDesigns, isPricingV2Enabled, planFromHas } from '../billing/pricingV2';

const OFF = Object.freeze({ enabled: false, plan: null, enrolled: Object.freeze([]) });

export const pricingV2State = (organization, has) =>
  isPricingV2Enabled(organization) && typeof has === 'function'
    ? { enabled: true, plan: planFromHas(has), enrolled: enrolledAutoSyncDesigns(organization) }
    : OFF;

export const usePricingV2 = () => {
  const { organization } = useOrganization();
  const { has } = useAuth();
  return { ...pricingV2State(organization, has), reloadOrganization: () => organization?.reload() };
};
